/** The most digits a US phone number carries — what a `tel` input accepts before it stops taking input. */
export const PHONE_NUMBER_DIGITS = 10;

/**
 * Digits only, capped at a whole phone number. This is the value a `tel` HInput reports through
 * onChange: canonical, safe to store, and what isPhoneNumber() counts.
 */
export const toPhoneDigits = (phoneNumber?: string | number): string =>
    String(phoneNumber ?? "")
        .replace(/\D/g, "")
        .slice(0, PHONE_NUMBER_DIGITS);

/**
 * (555) 123-4567, formatted as far as the digits go. Takes digits or an already-formatted number,
 * so it can be applied to a stored value and to its own output alike.
 */
export const formatPhone = (phoneNumber?: string | number): string => {
    if (!phoneNumber) return "";
    const digits = toPhoneDigits(phoneNumber);
    if (!digits) return "";
    if (digits.length <= 3) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
